import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { CalculatorListSection } from "web_myplann/Calculators/Components/CalculatorListSection";
import type { CalculatorAccessMap } from "web_myplann/Calculators/Types/CalculatorAccess";
import type { CalculatorSection } from "web_myplann/Calculators/Types/CalculatorSection";
import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";

type Props = {
	sections: CalculatorSection[];
	access: CalculatorAccessMap;
	onSelect: (type: CalculatorType) => void;
	onUnavailableSelect: (type: CalculatorType) => void;
};

export const CalculatorSectionList: FC<Props> = ({
	sections,
	access,
	onSelect,
	onUnavailableSelect,
}) => {
	const theme = useTheme();

	return (
		<Stack minHeight="100%" pb={theme.spacingTokens.xxl}>
			{sections.map((section) => (
				<CalculatorListSection
					key={section.key}
					section={section}
					access={access}
					onSelect={onSelect}
					onUnavailableSelect={onUnavailableSelect}
				/>
			))}
		</Stack>
	);
};
